import { render, staticRenderFns } from "./CustomerReview.vue?vue&type=template&id=518b7954&"
import script from "./CustomerReview.vue?vue&type=script&lang=js&"
export * from "./CustomerReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports